/**
 * License Card Component
 * 
 * Displays a single license card with badge, details, and actions
 * Used in My Licenses page
 */

import React from 'react';
import './LicenseCard.css';

const LicenseCard = ({ license, onViewContent }) => {
  const getGrantTypeLabel = (grantType) => {
    switch (grantType) {
      case 'owner':
        return '👤 Your Job';
      case 'request_approved':
        return '✅ Free Access';
      case 'purchase':
        return '💳 Purchased';
      default:
        return '';
    }
  };

  const getGrantTypeColor = (grantType) => {
    switch (grantType) {
      case 'owner':
        return 'owner-badge';
      case 'request_approved':
        return 'approved-badge';
      case 'purchase':
        return 'purchased-badge';
      default:
        return '';
    }
  };

  return (
    <div className="license-card">
      {/* Badge */}
      <div className={`license-badge ${getGrantTypeColor(license.grantType)}`}>
        {getGrantTypeLabel(license.grantType)}
      </div>

      {/* Content */}
      <div className="license-content">
        <h3 className="license-title">
          {license.job?.selectedModel || 'AI Analysis'}
        </h3>

        <div className="license-meta">
          <div className="meta-item">
            <strong>Source:</strong>{' '}
            {license.showCasefileName 
              ? license.casefileName 
              : 'Private Investigation'}
          </div>
          
          <div className="meta-item">
            <strong>Granted:</strong>{' '}
            {license.createdAt?.toDate().toLocaleDateString()}
          </div>

          {license.price && (
            <div className="meta-item price">
              <strong>Price:</strong> ${license.price}
            </div>
          )}
        </div>

        {/* Permissions */}
        <div className="license-permissions">
          {license.permissions?.viewVideo && '📹 Video'}
          {license.permissions?.viewAnalysis && '📊 Analysis'}
          {license.permissions?.exportData && '💾 Export'}
        </div>

        {/* Revocable Warning */}
        {license.revocable && (
          <div className="revocable-notice">
            ⚠️ Owner can revoke this access
          </div>
        )}
      </div>

      {/* View Button */}
      <button 
        className="view-license-btn"
        onClick={() => onViewContent(license)}
      >
        ▶️ View Content
      </button>
    </div>
  );
};

export default LicenseCard;

